import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-access-request" },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "can-cancel": true,
          "is-full-page": true,
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c(
        VForm,
        {
          ref: "form",
          staticClass: "form",
          attrs: { "lazy-validation": "" },
          model: {
            value: _vm.valid,
            callback: function ($$v) {
              _vm.valid = $$v
            },
            expression: "valid",
          },
        },
        [
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Applicant"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      small: "",
                      dense: "",
                      readonly: "",
                      type: "email",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.user_email,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "user_email", $$v)
                      },
                      expression: "requestObj.user_email",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Business Case"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      small: "",
                      dense: "",
                      readonly: "",
                      type: "email",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.business_case,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "business_case", $$v)
                      },
                      expression: "requestObj.business_case",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Company Business Case"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      small: "",
                      dense: "",
                      readonly: "",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.company,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "company", $$v)
                      },
                      expression: "requestObj.company",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Company Billing"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      small: "",
                      dense: "",
                      readonly: "",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.domain,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "domain", $$v)
                      },
                      expression: "requestObj.domain",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Project GCP"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      small: "",
                      dense: "",
                      readonly: "",
                      type: "email",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.pr_gcp,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "pr_gcp", $$v)
                      },
                      expression: "requestObj.pr_gcp",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Instance Type"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      "background-color": _vm.typeUpdate
                        ? "light-blue lighten-4"
                        : "",
                      small: "",
                      dense: "",
                      readonly: "",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.mt,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "mt", $$v)
                      },
                      expression: "requestObj.mt",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("GPU"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VCheckbox, {
                    attrs: { readonly: "", filled: "" },
                    model: {
                      value: _vm.requestObj.gpu,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "gpu", $$v)
                      },
                      expression: "requestObj.gpu",
                    },
                  }),
                ],
                1
              ),
              _vm.requestObj.gpu === true
                ? [
                    _c(
                      VCol,
                      { attrs: { cols: "3", lg: "2" } },
                      [
                        _c(VSubheader, { staticClass: "font-weight-bold" }, [
                          _vm._v("Cores"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      VCol,
                      { attrs: { cols: "9", lg: "4" } },
                      [
                        _c(VCheckbox, {
                          attrs: { readonly: "", filled: "" },
                          model: {
                            value: _vm.requestObj.core,
                            callback: function ($$v) {
                              _vm.$set(_vm.requestObj, "core", $$v)
                            },
                            expression: "requestObj.core",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Gitlab Repository"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VCheckbox, {
                    attrs: { readonly: "", filled: "" },
                    model: {
                      value: _vm.requestObj.gitlab,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "gitlab", $$v)
                      },
                      expression: "requestObj.gitlab",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Image Type"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9", lg: "4" } },
                [
                  _c(VTextField, {
                    attrs: {
                      small: "",
                      dense: "",
                      readonly: "",
                      required: "",
                      filled: "",
                    },
                    model: {
                      value: _vm.requestObj.image,
                      callback: function ($$v) {
                        _vm.$set(_vm.requestObj, "image", $$v)
                      },
                      expression: "requestObj.image",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "3", lg: "2" } },
                [
                  _c(VSubheader, { staticClass: "font-weight-bold" }, [
                    _vm._v("Response"),
                  ]),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "9" } },
                [
                  _c(VTextarea, {
                    attrs: {
                      rules: [
                        function (v) {
                          return v !== "" || "Field required"
                        },
                      ],
                      outlined: "",
                      "auto-grow": "",
                      clearable: "",
                      counter: "",
                      required: "",
                    },
                    model: {
                      value: _vm.response,
                      callback: function ($$v) {
                        _vm.response = $$v
                      },
                      expression: "response",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }